import { createAction } from '@reduxjs/toolkit';
import { PaginationType } from 'commons/framework/type';
import LibraryParamVO from 'commons/vo/param/LibraryParamVO';
import LibraryVO from 'commons/vo/Library';

import {
  DOWNLOAD_LIBRARY,
  DOWNLOAD_LIBRARY_FAILURE,
  DOWNLOAD_LIBRARY_SUCCESS,
  DOWNLOAD_LIBRARY_CLOUDFRONT,
  DOWNLOAD_LIBRARY_CLOUDFRONT_FAILURE,
  DOWNLOAD_LIBRARY_CLOUDFRONT_SUCCESS,
  INSERT_LIBRARY,
  INSERT_LIBRARY_FAILURE,
  INSERT_LIBRARY_SUCCESS,
  REQUEST_LIBRARY_COUNT,
  REQUEST_LIBRARY_COUNT_FAILURE,
  REQUEST_LIBRARY_COUNT_SUCCESS,
  REQUEST_LIBRARY_LIST,
  REQUEST_LIBRARY_LIST_FAILURE,
  REQUEST_LIBRARY_LIST_SUCCESS,
  REQUEST_MEDIACONVERT_JOB_LIST,
  REQUEST_MEDIACONVERT_JOB_LIST_FAILURE,
  REQUEST_MEDIACONVERT_JOB_LIST_SUCCESS,
} from './types';
import MediaconvertJobVO from 'commons/vo/MediaconvertJob/MediaconvertJob';

/**
 * [5] 보관함 관련 액션
 */
export const requestLibraryList = createAction<
  { param: LibraryParamVO },
  typeof REQUEST_LIBRARY_LIST
>(REQUEST_LIBRARY_LIST);
export const requestLibraryListSuccess = createAction<
  {
    libraryList: LibraryVO[];
    pagination: PaginationType;
    waitingCount: number;
  },
  typeof REQUEST_LIBRARY_LIST_SUCCESS
>(REQUEST_LIBRARY_LIST_SUCCESS);
export const requestLibraryListFailure = createAction(REQUEST_LIBRARY_LIST_FAILURE);

export const requestLibraryCount = createAction<
  { param: LibraryParamVO },
  typeof REQUEST_LIBRARY_COUNT
>(REQUEST_LIBRARY_COUNT);
export const requestLibraryCountSuccess = createAction<
  { count: number },
  typeof REQUEST_LIBRARY_COUNT_SUCCESS
>(REQUEST_LIBRARY_COUNT_SUCCESS);
export const requestLibraryCountFailure = createAction(REQUEST_LIBRARY_COUNT_FAILURE);

export const insertLibrary = createAction<{ param: LibraryParamVO }, typeof INSERT_LIBRARY>(
  INSERT_LIBRARY,
);
export const insertLibrarySuccess = createAction(INSERT_LIBRARY_SUCCESS);
export const insertLibraryFailure = createAction(INSERT_LIBRARY_FAILURE);

export const downloadLibrary = createAction<
  {
    id: number;
    assetId: number;
  },
  typeof DOWNLOAD_LIBRARY
>(DOWNLOAD_LIBRARY);
export const downloadLibrarySuccess = createAction(DOWNLOAD_LIBRARY_SUCCESS);
export const downloadLibraryFailure = createAction(DOWNLOAD_LIBRARY_FAILURE);

export const downloadLibraryCloudfront = createAction<
  {
    videoPath: string;
    videoId: number;
    id: number;
    filename: string;
  },
  typeof DOWNLOAD_LIBRARY_CLOUDFRONT
>(DOWNLOAD_LIBRARY_CLOUDFRONT);
export const downloadLibraryCloudfrontSuccess = createAction(DOWNLOAD_LIBRARY_CLOUDFRONT_SUCCESS);
export const downloadLibraryCloudfrontFailure = createAction(DOWNLOAD_LIBRARY_CLOUDFRONT_FAILURE);

/**
 * Mediaconvert
 */
export const requestMediaconvertJobList = createAction<
  { param: LibraryParamVO },
  typeof REQUEST_MEDIACONVERT_JOB_LIST
>(REQUEST_MEDIACONVERT_JOB_LIST);
export const requestMediaconvertJobListSuccess = createAction<
  {
    libraryList: MediaconvertJobVO[];
    pagination: PaginationType;
    waitingCount: number;
  },
  typeof REQUEST_MEDIACONVERT_JOB_LIST_SUCCESS
>(REQUEST_MEDIACONVERT_JOB_LIST_SUCCESS);
export const requestMediaconvertJobListFailure = createAction(
  REQUEST_MEDIACONVERT_JOB_LIST_FAILURE,
);
